/**
 * HTTP header parsing utilities
 */

export function getResponseHeaders(response: Response | Headers): Headers {
  if (response instanceof Response) {
    return response.headers;
  }
  return response;
}

export function getRetryAfter(response: Response | Headers): number {
  const headers = getResponseHeaders(response);
  const retryAfter = headers.get('retry-after');
  return retryAfter ? parseInt(retryAfter, 10) : 0;
}

export function getRemainingMethod(response: Response | Headers): number {
  const headers = getResponseHeaders(response);
  const remaining = headers.get('x-ratelimit-method-remaining');
  return remaining ? parseInt(remaining, 10) : -1;
}

export function getMethodRateLimit(response: Response | Headers): number {
  const headers = getResponseHeaders(response);
  const limit = headers.get('x-ratelimit-method-limit');
  return limit ? parseInt(limit, 10) : 0;
}

export function getRpsLimit(response: Response | Headers): number {
  const headers = getResponseHeaders(response);
  const limit = headers.get('x-ratelimit-rps-limit');
  return limit ? parseInt(limit, 10) : 0;
}
